/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AccountData = {
  accountDiscount?: InputMaybe<AccountDiscount>;
  credit?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  newCustomer: Scalars['Boolean']['input'];
};

export type AccountDiscount = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  d1MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  d2MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  freeShipping: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  newCustomerOnly: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
  totalMealMinimum?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  weeksToApply?: InputMaybe<Scalars['Int']['input']>;
};

export type AddVariantToCartDeliveryInput = {
  quantity: Scalars['Int']['input'];
  /** ID of the Variant in the ecomm-catalog-service */
  variantId: Scalars['Int']['input'];
};

export type ApplePay = {
  __typename?: 'ApplePay';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export type ApplePayV2 = {
  __typename?: 'ApplePayV2';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export type Cart = {
  __typename?: 'Cart';
  cartDeliveries: Array<CartDelivery>;
  cartError?: Maybe<CartError>;
  cartLedger?: Maybe<CartLedger>;
  createdAt: Scalars['DateTime']['output'];
  customizeBy?: Maybe<Scalars['DateTime']['output']>;
  deliveryDates: Scalars['JSON']['output'];
  deliveryWeek: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  discountErrors?: Maybe<Array<Scalars['String']['output']>>;
  funnelData: Scalars['JSON']['output'];
  legacyOrderId?: Maybe<Scalars['Float']['output']>;
  mealSize: MealSize;
  orderOn?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<CartPaymentMethodV2>;
  recipientName: Scalars['String']['output'];
  status: CartStatus;
  subscription?: Maybe<SubscriptionEntityV2>;
  tenantEligibilityConfigLogicalId: Scalars['String']['output'];
  tenantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type CartDataInternalInput = {
  legacyOrderId: Scalars['Int']['input'];
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  /** Captures all used query params on cart creation */
  queryParams?: InputMaybe<Scalars['JSON']['input']>;
  recipientName: Scalars['String']['input'];
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a delivery of products */
export type CartDelivery = {
  __typename?: 'CartDelivery';
  cart: Cart;
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['Date']['output'];
  deliveryType: Scalars['Int']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  estimatedTransitTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lineItems: Array<CartDeliveryLineItem>;
  location?: Maybe<CartLocationV2>;
  /** This should reference a location object associated with the customer */
  locationId?: Maybe<Scalars['Int']['output']>;
  orderDelivery?: Maybe<OrderDelivery>;
  status: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems: Array<CartLineItemInput>;
};

export type CartDeliveryLineItem = {
  __typename?: 'CartDeliveryLineItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Catalog variant data pulled from cache or ecomm-catalogs */
  variant?: Maybe<Scalars['JSON']['output']>;
  variantId: Scalars['Int']['output'];
};

export type CartDeliveryResult = CartDelivery | CartError;

export type CartError = {
  __typename?: 'CartError';
  validation?: Maybe<CartValidation>;
};

export type CartLedger = {
  __typename?: 'CartLedger';
  createdAt: Scalars['DateTime']['output'];
  creditTotal: Scalars['Int']['output'];
  deliveryTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  precreditTotal: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartLineItemInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type CartLocationV2 = {
  __typename?: 'CartLocationV2';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  dropoffLocation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CartPaymentMethodV2 = ApplePayV2 | CreditCardV2 | PayPalV2;

export type CartResult = Cart | CartError;

export enum CartStatus {
  /** The cart has been canceled. At time of writing, this only occurs when a user cancels their own cart, for something like skipping a week. */
  Canceled = 'CANCELED',
  /** The cart failed processing. This is most commonly caused by payment failure but can also be caused by internal errors. */
  FailedProcessing = 'FAILED_PROCESSING',
  /** The cart has been created but is not yet eligible for processing. */
  Initialized = 'INITIALIZED',
  /** The cart is eligible for processing but has not yet been processed. Payment has not yet been collected and fulfillment artifacts have not been created. */
  PendingProcessing = 'PENDING_PROCESSING',
  /** The cart was successfully processed. Payment has been collected and fulfillment artifacts have been generated. */
  Processed = 'PROCESSED',
  /** The cart is being processed and can no longer be modified. */
  Processing = 'PROCESSING',
  /** The cart has been queued for processing and can no longer be modified. */
  Queued = 'QUEUED'
}

export type CartValidation = {
  __typename?: 'CartValidation';
  address?: Maybe<Array<ValidationError>>;
  catalog?: Maybe<Array<ValidationError>>;
  customizeBy?: Maybe<Array<ValidationError>>;
  giftNotes?: Maybe<Array<ValidationError>>;
  quantity?: Maybe<Array<ValidationError>>;
  soldOutItem?: Maybe<Array<ValidationError>>;
  status?: Maybe<Array<ValidationError>>;
};

export type CartValidationError = {
  __typename?: 'CartValidationError';
  validation?: Maybe<CartValidation>;
};

export type CheckoutCartError = {
  __typename?: 'CheckoutCartError';
  cartValidation?: Maybe<CartValidationError>;
  inactiveCatalog?: Maybe<Scalars['String']['output']>;
  invalidCart?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckoutCartResult = Cart | CheckoutCartError;

export type CreateCartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems?: InputMaybe<Array<CreateCartDeliveryLineItemInput>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCartDeliveryLineItemInput = {
  price: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variant?: InputMaybe<Scalars['JSON']['input']>;
  variantId: Scalars['Int']['input'];
};

export type CreateCartInput = {
  /** Must be a Sunday */
  deliveryWeek?: InputMaybe<Scalars['Date']['input']>;
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  /** Captures all used query params on cart creation */
  queryParams?: InputMaybe<Scalars['JSON']['input']>;
  recipientName: Scalars['String']['input'];
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFunnelDataInput = {
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  dietaryTemplateId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  mealSize: Scalars['String']['input'];
  name: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export type CreditCardV2 = {
  __typename?: 'CreditCardV2';
  displayName: Scalars['String']['output'];
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  /** The payment process network (e.g. Visa, MasterCard) */
  network: Scalars['String']['output'];
};

export enum DeliveryType {
  Local = 'Local',
  Shipping = 'Shipping'
}

export type Designer = {
  __typename?: 'Designer';
  name: Scalars['String']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DraftCart = {
  __typename?: 'DraftCart';
  cartDeliveries: Array<DraftCartDelivery>;
  cartError?: Maybe<DraftCartError>;
  cartLedger: DraftCartLedger;
  deliveryDates: Array<Scalars['Date']['output']>;
  discount?: Maybe<Discount>;
};

/** A cart delivery that does not exist in the database */
export type DraftCartDelivery = {
  __typename?: 'DraftCartDelivery';
  deliveryDate: Scalars['Date']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  estimatedTransitTime?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<DraftCartDeliveryLineItem>;
};

export type DraftCartDeliveryLineItem = {
  __typename?: 'DraftCartDeliveryLineItem';
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  /** Catalog variant data pulled from cache or ecomm-catalogs */
  variant?: Maybe<Scalars['JSON']['output']>;
  variantId: Scalars['Int']['output'];
};

export type DraftCartError = {
  __typename?: 'DraftCartError';
  validation: DraftCartValidation;
};

export type DraftCartLedger = {
  __typename?: 'DraftCartLedger';
  creditTotal: Scalars['Int']['output'];
  deliveryTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  precreditTotal: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
};

export type DraftCartValidation = {
  __typename?: 'DraftCartValidation';
  catalog?: Maybe<Array<ValidationError>>;
  quantity?: Maybe<Array<ValidationError>>;
  soldOutItem?: Maybe<Array<ValidationError>>;
};

export type EvaluateDraftCartDeliveryInput = {
  deliveryDate: Scalars['Date']['input'];
  lineItems: Array<EvaluateDraftCartLineItemInput>;
};

export type EvaluateDraftCartInput = {
  cartDeliveries: Array<EvaluateDraftCartDeliveryInput>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
};

export type EvaluateDraftCartLineItemInput = {
  /** Used as a mechanism to detect new items being incremented, and validate soldOut items to filter them out and not evaluate them (as of 04/23) */
  new?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type IngredientToAvoid = {
  __typename?: 'IngredientToAvoid';
  category: IngredientToAvoidCategory;
  displayName: Scalars['String']['output'];
  isAllergen: Scalars['Boolean']['output'];
  legacyAllergenItemId: Scalars['Int']['output'];
};

export type IngredientToAvoidCategory = {
  __typename?: 'IngredientToAvoidCategory';
  displayName: Scalars['String']['output'];
  legacyAllergenCategoryId: Scalars['Int']['output'];
};

export type IngredientToAvoidCategoryV2 = {
  __typename?: 'IngredientToAvoidCategoryV2';
  displayName: Scalars['String']['output'];
  legacyAllergenCategoryId: Scalars['Int']['output'];
};

export type IngredientToAvoidV2 = {
  __typename?: 'IngredientToAvoidV2';
  category: IngredientToAvoidCategoryV2;
  displayName: Scalars['String']['output'];
  isAllergen: Scalars['Boolean']['output'];
  legacyAllergenItemId: Scalars['Int']['output'];
};

export type Location = {
  __typename?: 'Location';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type MacroNutrients = {
  __typename?: 'MacroNutrients';
  caloriesInG: Scalars['Float']['output'];
  /** @deprecated Should have been using total carbs in G all along */
  netCarbsInG?: Maybe<Scalars['Float']['output']>;
  proteinInG: Scalars['Float']['output'];
  totalCarbsInG: Scalars['Float']['output'];
  totalFatInG: Scalars['Float']['output'];
};

export type MacroPreferencesGraphQl = {
  __typename?: 'MacroPreferencesGraphQL';
  addedSugarInG?: Maybe<Range>;
  calories?: Maybe<Range>;
  cholesterolInMg?: Maybe<Range>;
  dietaryFiberInG?: Maybe<Range>;
  netCarbsInG?: Maybe<Range>;
  proteinInG?: Maybe<Range>;
  saturatedFatInG?: Maybe<Range>;
  servingSizeInOz?: Maybe<Range>;
  sodiumInMg?: Maybe<Range>;
  sugarsInG?: Maybe<Range>;
  totalCarbsInG?: Maybe<Range>;
  totalFatInG?: Maybe<Range>;
};

export type MacroPreferencesInput = {
  addedSugarInG?: InputMaybe<RangeInput>;
  calories?: InputMaybe<RangeInput>;
  cholesterolInMg?: InputMaybe<RangeInput>;
  dietaryFiberInG?: InputMaybe<RangeInput>;
  netCarbsInG?: InputMaybe<RangeInput>;
  proteinInG?: InputMaybe<RangeInput>;
  saturatedFatInG?: InputMaybe<RangeInput>;
  servingSizeInOz?: InputMaybe<RangeInput>;
  sodiumInMg?: InputMaybe<RangeInput>;
  sugarsInG?: InputMaybe<RangeInput>;
  totalCarbsInG?: InputMaybe<RangeInput>;
  totalFatInG?: InputMaybe<RangeInput>;
};

export type MealSize = {
  __typename?: 'MealSize';
  displayName: Scalars['String']['output'];
};

export type Metro = {
  __typename?: 'Metro';
  /** The deadline for customizing the current week */
  currentModifyDeadline: Scalars['DateTime']['output'];
  /** The value of `metros.id` in the rails app. */
  legacyRailsId: Scalars['Int']['output'];
  /** Monday and Thursday dates, which are recognized by the legacy rails app. */
  legacySystemShoppableDeliveryDates: Array<Scalars['Date']['output']>;
  /** The currently-shoppable delivery dates for the metro */
  shoppableDeliveryDates: Array<Scalars['Date']['output']>;
};

export type MetroDataInput = {
  additionalDeliveryFeeCents: Scalars['Int']['input'];
  allowedZips: Array<Scalars['String']['input']>;
  chargeOn: Scalars['String']['input'];
  customizeBy: Scalars['String']['input'];
  deliveryDates: Array<Scalars['String']['input']>;
  deliveryFeeCents: Scalars['Int']['input'];
  deliveryType: Scalars['String']['input'];
  /** Must be a Sunday */
  deliveryWeek: Scalars['Date']['input'];
  estimatedTransitTime?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  metroStates: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable: Scalars['Boolean']['input'];
  prices: Array<Prices>;
  regionalShipping: Scalars['Boolean']['input'];
  sustainableZips: Array<Scalars['String']['input']>;
  ttl: Scalars['Int']['input'];
  validMealQuantities: Array<Scalars['Int']['input']>;
};

export type MetroV2 = {
  __typename?: 'MetroV2';
  /** The deadline for customizing the current week */
  currentModifyDeadline: Scalars['DateTime']['output'];
  /** The value of `metros.id` in the rails app. */
  legacyRailsId: Scalars['Int']['output'];
  /** Monday and Thursday dates, which are recognized by the legacy rails app. */
  legacySystemShoppableDeliveryDates: Array<Scalars['Date']['output']>;
  /** The currently-shoppable delivery dates for the metro */
  shoppableDeliveryDates: Array<Scalars['Date']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCodeToCart: Cart;
  addCodeToCartV2: CartResult;
  addVariantToCartDeliveryV2: CartDeliveryResult;
  /** Remove all catalog and variant cache entries from the cache */
  bustCatalogCache: Scalars['Boolean']['output'];
  /** Remove all variant entries from and refresh the delivery containers in the delivery container service in-memory cache */
  bustDeliveryContainerServiceCache: Scalars['Boolean']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  cancelSubscriptionInternal: Scalars['Boolean']['output'];
  cancelSubscriptionV2: SubscriptionEntityV2;
  checkoutCart: CheckoutCartResult;
  createCart: Cart;
  createCartInternal: CartResult;
  /** Validates and prices a draft cart without persisting it. Pricing is dependent upon the currently-authenticated user. If any of the cart validations fail, a draft cart object is guaranteed to be returned with cart deliveries for supported delivery dates */
  evaluateDraftCart: DraftCart;
  modifySubscriptionPauses: SubscriptionEntityV2;
  processCart: ProcessCartResult;
  processPaymentFailure: ProcessCartResult;
  processPaymentSuccess: ProcessCartResult;
  removeVariantFromCartDeliveryV2: CartDeliveryResult;
  repriceCart: Cart;
  repriceCartInternal: CartResult;
  repriceCartV2: CartResult;
  repriceCartsByIdInternal: Array<CartResult>;
  updateBulkSubscriptionSkuFavorites: Array<SkuFavoriteGraphQl>;
  updateBulkSubscriptionSkuOptOut: Array<Sku>;
  updateCartDelivery: CartDelivery;
  updateCartDeliveryV2: CartDeliveryResult;
  updateCartV2: CartResult;
  updateCartV2Internal: CartResult;
  updatePaymentMethod: SubscriptionEntityV2;
  updateSubscriptionLocation: SubscriptionEntityV2;
  updateSubscriptionPrefs: SubscriptionEntityV2;
};


export type MutationAddCodeToCartArgs = {
  code: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationAddCodeToCartV2Args = {
  code: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationAddVariantToCartDeliveryV2Args = {
  cartDeliveryId: Scalars['Int']['input'];
  cartUUID: Scalars['UUID']['input'];
  variantInput: AddVariantToCartDeliveryInput;
};


export type MutationCancelSubscriptionArgs = {
  legacyOrderId: Scalars['Int']['input'];
};


export type MutationCancelSubscriptionInternalArgs = {
  cancelLegacyOrder?: InputMaybe<Scalars['Boolean']['input']>;
  legacyOrderId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCancelSubscriptionV2Args = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<SubscriptionCancellationReason>;
  reason?: InputMaybe<Scalars['String']['input']>;
  userComments?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};


export type MutationCheckoutCartArgs = {
  giftNotes?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};


export type MutationCreateCartArgs = {
  cartData: CreateCartInput;
  funnelData: CreateFunnelDataInput;
};


export type MutationCreateCartInternalArgs = {
  cartData: CartDataInternalInput;
  cartDeliveryData: Array<CreateCartDeliveryInput>;
  discountData?: InputMaybe<PriceCartDiscount>;
  funnelData: CreateFunnelDataInput;
  metroData: MetroDataInput;
  tenantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationEvaluateDraftCartArgs = {
  draftCart: EvaluateDraftCartInput;
  recurringSubscription: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};


export type MutationModifySubscriptionPausesArgs = {
  pauseMap: Scalars['JSONObject']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationProcessCartArgs = {
  legacyOrderId: Scalars['Int']['input'];
  orderOn: Scalars['String']['input'];
};


export type MutationProcessPaymentFailureArgs = {
  failureReason: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationProcessPaymentSuccessArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRemoveVariantFromCartDeliveryV2Args = {
  cartDeliveryId: Scalars['Int']['input'];
  cartUUID: Scalars['UUID']['input'];
  variantInput: RemoveVariantInput;
};


export type MutationRepriceCartArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRepriceCartInternalArgs = {
  deliveryWeek: Scalars['Date']['input'];
  legacyOrderId: Scalars['Int']['input'];
};


export type MutationRepriceCartV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRepriceCartsByIdInternalArgs = {
  cartIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateBulkSubscriptionSkuFavoritesArgs = {
  input: UpdateSkuFavoritesInput;
};


export type MutationUpdateBulkSubscriptionSkuOptOutArgs = {
  skus: Array<Scalars['String']['input']>;
  subscriptionUuid: Scalars['String']['input'];
};


export type MutationUpdateCartDeliveryArgs = {
  deliveryData: UpdateCartDeliveryInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCartDeliveryV2Args = {
  deliveryData: UpdateCartDeliveryInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateCartV2Args = {
  cartData?: InputMaybe<UpdateCartInput>;
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdateCartV2InternalArgs = {
  cartData?: InputMaybe<UpdateCartInput>;
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  userId: Scalars['Int']['input'];
  uuid: Scalars['UUID']['input'];
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionLocationArgs = {
  input: UpdateSubscriptionLocationInput;
};


export type MutationUpdateSubscriptionPrefsArgs = {
  prefs: UpdateSubscriptionPrefsInput;
};

export type Order = {
  __typename?: 'Order';
  cart: Cart;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

/** Representation of a processed cart delivery */
export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  trackingId?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type PayPal = {
  __typename?: 'PayPal';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type PayPalV2 = {
  __typename?: 'PayPalV2';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type PaymentMethod = ApplePay | CreditCard | PayPal;

export type PaymentMethodV2 = ApplePayV2 | CreditCardV2 | PayPalV2;

export type PriceCartDelivery = {
  cartDeliveryLineItems: Array<PriceCartDeliveryLineItem>;
  deliveryDate: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};

export type PriceCartDeliveryLineItem = {
  price: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

export type PriceCartDiscount = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  d1MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  d2MealMinimum?: InputMaybe<Scalars['Int']['input']>;
  freeShipping: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  newCustomerOnly: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
  totalMealMinimum?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  weeksToApply?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCartInput = {
  cartDeliveries: Array<PriceCartDelivery>;
  discount?: InputMaybe<PriceCartDiscount>;
  funnelData: PriceFunnelData;
  tenantId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type PriceFunnelData = {
  mealSize: Scalars['String']['input'];
  metro: PriceMetro;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type PriceMetro = {
  deliveryType: DeliveryType;
  id: Scalars['Int']['input'];
  regionalShipping: Scalars['Boolean']['input'];
  shippingCosts: Scalars['JSON']['input'];
};

export type Prices = {
  calories: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type ProcessCartResult = Cart | CartError;

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  designer: Designer;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  cart?: Maybe<Cart>;
  cartDelivery: CartDelivery;
  cartInternal?: Maybe<Cart>;
  dashboardSubscriptionsV2: Array<SubscriptionEntityV2>;
  priceCart: CartLedger;
  subscriptionV2: SubscriptionEntityV2;
  subscriptions: Array<SubscriptionEntity>;
  subscriptionsV2: Array<SubscriptionEntityV2>;
};


export type QueryCartArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCartDeliveryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCartInternalArgs = {
  deliveryWeek: Scalars['Date']['input'];
  legacyOrderId: Scalars['Int']['input'];
};


export type QueryPriceCartArgs = {
  accountData: AccountData;
  cartData: PriceCartInput;
};


export type QuerySubscriptionV2Args = {
  uuid: Scalars['UUID']['input'];
};

export type Range = {
  __typename?: 'Range';
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min: Scalars['Int']['input'];
};

export type RemoveVariantInput = {
  quantity: Scalars['Int']['input'];
  /** ID of the Variant in the ecomm-catalog-service */
  variantId: Scalars['Int']['input'];
};

export type ShimmedCart = {
  __typename?: 'ShimmedCart';
  cartDeliveries: Array<ShimmedCartDelivery>;
  cartError?: Maybe<CartError>;
  cartLedger?: Maybe<CartLedger>;
  chargeOn: Scalars['Date']['output'];
  createdAt: Scalars['DateTime']['output'];
  customizeBy?: Maybe<Scalars['DateTime']['output']>;
  deliveryDates: Scalars['JSON']['output'];
  deliveryWeek: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  displayName: Scalars['String']['output'];
  funnelData: Scalars['JSON']['output'];
  legacyOrderId?: Maybe<Scalars['Float']['output']>;
  mealSize: MealSize;
  /** Keeping for backwards compatibility, but we now use customizeBy for the same reason */
  modifyDeadline: Scalars['DateTime']['output'];
  orderOn?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  recipientName: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ShimmedCartDelivery = {
  __typename?: 'ShimmedCartDelivery';
  cartDeliveryLineItems: Array<ShimmedCartDeliveryLineItem>;
  deliveryDate: Scalars['Date']['output'];
  deliveryType: Scalars['Int']['output'];
  estimatedDeliveryDate: Scalars['Date']['output'];
  estimatedTransitTime: Scalars['Int']['output'];
  location: Location;
  /** This should reference a location object associated with the customer */
  locationId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['Int']['output'];
};

export type ShimmedCartDeliveryLineItem = {
  __typename?: 'ShimmedCartDeliveryLineItem';
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  variant: Variant;
  variantId: Scalars['Int']['output'];
};

export type Sku = {
  __typename?: 'Sku';
  photoUrl: Scalars['String']['output'];
  sameSkus: Array<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SkuFavoriteGraphQl = SkuParent & {
  __typename?: 'SkuFavoriteGraphQL';
  day: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  sku: Sku;
};

export type SkuFavoritesInput = {
  day: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type SkuOptOutGraphQl = SkuParent & {
  __typename?: 'SkuOptOutGraphQL';
  sku: Sku;
};

export type SkuParent = {
  sku: Sku;
};

export type SubscriptionCancellation = {
  __typename?: 'SubscriptionCancellation';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

export enum SubscriptionCancellationReason {
  BillingIssues = 'BILLING_ISSUES',
  DeliveryIssues = 'DELIVERY_ISSUES',
  MealPricing = 'MEAL_PRICING',
  MealQuality = 'MEAL_QUALITY',
  MealVariety = 'MEAL_VARIETY',
  Other = 'OTHER'
}

export type SubscriptionDeliveryV2 = {
  __typename?: 'SubscriptionDeliveryV2';
  day: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  /** The absence of carts in this array indicates that a pause exists for the currently-modifiable week. */
  carts: Array<ShimmedCart>;
  displayName: Scalars['String']['output'];
  /** The value of `orders.id` in the rails app. Orders in the rails app are really subscriptions. */
  legacyOrderId: Scalars['Int']['output'];
  location: Location;
  /** The number of meals to be delivered per week according to the subscription settings */
  mealsPerWeek: Scalars['Int']['output'];
  metro: Metro;
  orders: Array<Order>;
  /** JSON map of ISO string date of the Sunday at the head of a delivery week to boolean indicating whether or not there is a pause for that delivery week */
  pauses: Scalars['JSONObject']['output'];
  paymentMethod: PaymentMethod;
  preferences: SubscriptionPreferences;
  recurring: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};


export type SubscriptionEntityOrdersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionEntityV2 = {
  __typename?: 'SubscriptionEntityV2';
  cancellation?: Maybe<SubscriptionCancellation>;
  carts: Array<Cart>;
  displayName: Scalars['String']['output'];
  endWeek?: Maybe<Scalars['Date']['output']>;
  legacyOrderId?: Maybe<Scalars['Float']['output']>;
  location: SubscriptionLocationV2;
  macroPreferences?: Maybe<MacroPreferencesGraphQl>;
  mealsPerWeek: Scalars['Int']['output'];
  metro: MetroV2;
  orders: Array<Order>;
  /** JSON map of ISO string date of the Sunday at the head of a delivery week to boolean indicating whether or not there is a pause for that delivery week */
  pauses: Scalars['JSONObject']['output'];
  paymentMethod?: Maybe<PaymentMethodV2>;
  preferences: SubscriptionPreferencesV2;
  startWeek: Scalars['Date']['output'];
  /** Should send `ACTIVE` or `INACTIVE` */
  status: Scalars['String']['output'];
  subscriptionDeliveries: Array<SubscriptionDeliveryV2>;
  uuid: Scalars['UUID']['output'];
};


export type SubscriptionEntityV2CartsArgs = {
  excludeProcessed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SubscriptionEntityV2OrdersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CartStatus>>;
};


export type SubscriptionEntityV2PausesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionLocationV2 = {
  __typename?: 'SubscriptionLocationV2';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  dropoffLocation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type SubscriptionPreferences = {
  __typename?: 'SubscriptionPreferences';
  dietaryTemplates: Array<Tag>;
  ingredientsToAvoid: Array<IngredientToAvoid>;
  mealSize: Scalars['String']['output'];
  mealTypes: Array<Tag>;
};

export type SubscriptionPreferencesV2 = {
  __typename?: 'SubscriptionPreferencesV2';
  ingredientsToAvoid: Array<IngredientToAvoidV2>;
  macros?: Maybe<MacroPreferencesGraphQl>;
  skuFavorites: Array<SkuFavoriteGraphQl>;
  skuOptOuts: Array<SkuOptOutGraphQl>;
  tags: Array<TagV2>;
};


export type SubscriptionPreferencesV2TagsArgs = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  category: TagCategory;
  displayName?: Maybe<Scalars['String']['output']>;
  displayValue: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagCategory = {
  __typename?: 'TagCategory';
  name: Scalars['String']['output'];
};

export type TagCategoryV2 = {
  __typename?: 'TagCategoryV2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TagV2 = {
  __typename?: 'TagV2';
  category: TagCategoryV2;
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UpdateCartDeliveryInput = {
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  lineItems?: InputMaybe<Array<CreateCartDeliveryLineItemInput>>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCartInput = {
  /** Overwrites the existing cart deliveries. Delivery dates should correspond to the eligible delivery dates found on the cart. If any dates are omitted from this input array, those deliveries will be created without any line items. A zero-length array results in no operation. */
  cartDeliveries?: InputMaybe<Array<CartDeliveryInput>>;
  orderOn?: InputMaybe<Scalars['Date']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  tenantEligibilityConfigLogicalId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunnelDataInput = {
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  dietaryTemplateId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  mealSize?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSkuFavoritesInput = {
  /** Sets the Sku favorites for this subscription. If an empty array is provided, it's assumed you want to unset all preferences. Undefined is a no-op. */
  skuFavorites?: InputMaybe<Array<SkuFavoritesInput>>;
  subscriptionUuid: Scalars['UUID']['input'];
};

export type UpdateSubscriptionDeliveries = {
  FRIDAY?: InputMaybe<Scalars['Int']['input']>;
  MONDAY?: InputMaybe<Scalars['Int']['input']>;
  SATURDAY?: InputMaybe<Scalars['Int']['input']>;
  SUNDAY?: InputMaybe<Scalars['Int']['input']>;
  THURSDAY?: InputMaybe<Scalars['Int']['input']>;
  TUESDAY?: InputMaybe<Scalars['Int']['input']>;
  WEDNESDAY?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSubscriptionLocationInput = {
  /** Location must belong to the same storefront currently associated with the subscription via the metroId */
  locationId: Scalars['Int']['input'];
  subscriptionUuid: Scalars['UUID']['input'];
};

/** Providing a null input for any preference results in no action. */
export type UpdateSubscriptionPrefsInput = {
  /** Omitting this field results in a no-op. An empty array, however, clears out the preferences. */
  ingredientsToAvoidIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Input for macro nutrient preferences defining min/max ranges */
  macros?: InputMaybe<MacroPreferencesInput>;
  /** Omitting this field results in a no-op. Updates will only be applied to the days provided as not null. Note that quantities are subject to metro-specific validation. */
  subscriptionDeliveries?: InputMaybe<UpdateSubscriptionDeliveries>;
  subscriptionUuid: Scalars['UUID']['input'];
  /** Omitting this field results in a no-op. An empty array, however, clears out the preferences. Note that this field may be subject to default values when cleared out. */
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  deliveryId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

export type Variant = {
  __typename?: 'Variant';
  macroNutrients: MacroNutrients;
  product: Product;
};

export type CreateCartMutationVariables = Exact<{
  funnelData: CreateFunnelDataInput;
  cartData: CreateCartInput;
}>;


export type CreateCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', uuid: any, funnelData: any } };

export type CreateAndReturnCartMutationVariables = Exact<{
  funnelData: CreateFunnelDataInput;
  cartData: CreateCartInput;
}>;


export type CreateAndReturnCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } };

export type UpdateCartMutationVariables = Exact<{
  funnelData?: InputMaybe<UpdateFunnelDataInput>;
  cartData?: InputMaybe<UpdateCartInput>;
  uuid: Scalars['UUID']['input'];
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', updateCart: { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type AddVariantToCartDeliveryMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: AddVariantToCartDeliveryInput;
}>;


export type AddVariantToCartDeliveryMutation = { __typename?: 'Mutation', addVariantToCartDelivery: { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, funnelData: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type RemoveVariantFromCartDeliveryMutationVariables = Exact<{
  cartUUID: Scalars['UUID']['input'];
  cartDeliveryId: Scalars['Int']['input'];
  variantInput: RemoveVariantInput;
}>;


export type RemoveVariantFromCartDeliveryMutation = { __typename?: 'Mutation', removeVariantFromCartDelivery: { __typename?: 'CartDelivery', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, tenantEligibilityConfigLogicalId: string, funnelData: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, creditTotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } | null } } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null } | null } };

export type AddCodeToCartMutationVariables = Exact<{
  code: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
}>;


export type AddCodeToCartMutation = { __typename?: 'Mutation', addCodeToCart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, funnelData: any, tenantEligibilityConfigLogicalId: string, status: CartStatus, discountErrors?: Array<string> | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, creditTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type RepriceCartMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type RepriceCartMutation = { __typename?: 'Mutation', repriceCart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, deliveryDates: any, funnelData: any, status: CartStatus, tenantEligibilityConfigLogicalId: string, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, creditTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type UpdateCartDeliveryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  deliveryData: UpdateCartDeliveryInput;
}>;


export type UpdateCartDeliveryMutation = { __typename?: 'Mutation', updateCartDelivery: { __typename?: 'CartDelivery', id: number, status: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null } | { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', status?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type EvaluateDraftCartMutationVariables = Exact<{
  draftCart: EvaluateDraftCartInput;
  zip: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  recurringSubscription: Scalars['Boolean']['input'];
}>;


export type EvaluateDraftCartMutation = { __typename?: 'Mutation', evaluateDraftCart: { __typename?: 'DraftCart', deliveryDates: Array<any>, discount?: { __typename?: 'Discount', code: string, amount: number, type: string } | null, cartDeliveries: Array<{ __typename?: 'DraftCartDelivery', estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'DraftCartDeliveryLineItem', variantId: number, quantity: number, price: number, variant?: any | null }> }>, cartLedger: { __typename?: 'DraftCartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, precreditTotal: number, grandTotal: number }, cartError?: { __typename?: 'DraftCartError', validation: { __typename?: 'DraftCartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } } | null } };

export type UpdateCartV2MutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  cartData: UpdateCartInput;
}>;


export type UpdateCartV2Mutation = { __typename?: 'Mutation', updateCartV2: { __typename: 'Cart', uuid: any, userId?: number | null, legacyOrderId?: number | null, status: CartStatus, funnelData: any, deliveryDates: any, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, precreditTotal: number, grandTotal: number } | null } | { __typename: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, soldOutItem?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } };

export type GetCartByIdQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetCartByIdQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, status: CartStatus, createdAt: any, legacyOrderId?: number | null, tenantEligibilityConfigLogicalId: string, funnelData: any, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, deliveryDate: any, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } | null };

export type AllCartFieldsFragment = { __typename?: 'Cart', uuid: any, recipientName: string, funnelData: any, orderOn?: any | null, userId?: number | null, tenantEligibilityConfigLogicalId: string, deliveryDates: any, status: CartStatus, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number, grandTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null };

export type CheckoutCartMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  giftNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutCartMutation = { __typename?: 'Mutation', checkoutCart: { __typename: 'Cart', uuid: any, legacyOrderId?: number | null, subscription?: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null } | null, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, tax: number } | null, discount?: { __typename?: 'Discount', code: string } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', price: number, quantity: number, variant?: any | null }> }> } | { __typename: 'CheckoutCartError', inactiveCatalog?: string | null, invalidCart?: boolean | null, cartValidation?: { __typename?: 'CartValidationError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, address?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } };

export type ConfirmationCartQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type ConfirmationCartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, funnelData: any, status: CartStatus, legacyOrderId?: number | null, recipientName: string, mealSize: { __typename?: 'MealSize', displayName: string }, subscription?: { __typename?: 'SubscriptionEntityV2', displayName: string, uuid: any, endWeek?: any | null, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', displayName: string }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null }, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }> } | null, paymentMethod?: { __typename: 'ApplePayV2', displayName: string, network: string, lastFour: string, expirationMonth: string, expirationYear: string } | { __typename: 'CreditCardV2', displayName: string, network: string, lastFour: string, expirationMonth: string, expirationYear: string } | { __typename: 'PayPalV2', displayName: string, email: string } | null, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryType: number, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', price: number, variant?: any | null, variantId: number, quantity: number, updatedAt: any }>, location?: { __typename?: 'CartLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null } | null }>, cartLedger?: { __typename?: 'CartLedger', subtotal: number, grandTotal: number, discountTotal: number, creditTotal: number, deliveryTotal: number, tax: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string } | null } | null };

export type GetSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionsQuery = { __typename?: 'Query', subscriptions: Array<{ __typename?: 'SubscriptionEntity', displayName: string, legacyOrderId: number, recurring: boolean, pauses: any, mealsPerWeek: number, metro: { __typename?: 'Metro', legacyRailsId: number, shoppableDeliveryDates: Array<any>, legacySystemShoppableDeliveryDates: Array<any>, currentModifyDeadline: any }, location: { __typename?: 'Location', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string }, paymentMethod: { __typename?: 'ApplePay', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCard', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPal', displayName: string, email: string }, carts: Array<{ __typename?: 'ShimmedCart', uuid: any, displayName: string, chargeOn: any, customizeBy?: any | null, deliveryWeek: any, modifyDeadline: any, discount?: { __typename?: 'Discount', code: string, amount: number, type: string } | null, cartLedger?: { __typename?: 'CartLedger', subtotal: number, discountTotal: number, deliveryTotal: number, grandTotal: number, precreditTotal: number, tax: number, creditTotal: number } | null, cartDeliveries: Array<{ __typename?: 'ShimmedCartDelivery', estimatedTransitTime: number, estimatedDeliveryDate: any, deliveryDate: any, deliveryType: number, status: number, location: { __typename?: 'Location', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string }, cartDeliveryLineItems: Array<{ __typename?: 'ShimmedCartDeliveryLineItem', quantity: number, price: number, variantId: number, variant: { __typename?: 'Variant', macroNutrients: { __typename?: 'MacroNutrients', caloriesInG: number, totalCarbsInG: number, proteinInG: number, totalFatInG: number }, product: { __typename?: 'Product', name: string, title: string, subtitle?: string | null, imageUrl?: string | null, designer: { __typename?: 'Designer', name: string } } } }> }>, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null }>, preferences: { __typename?: 'SubscriptionPreferences', mealSize: string, ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoid', displayName: string }>, dietaryTemplates: Array<{ __typename?: 'Tag', value: string, displayValue: string, category: { __typename?: 'TagCategory', name: string } }>, mealTypes: Array<{ __typename?: 'Tag', value: string, displayValue: string, category: { __typename?: 'TagCategory', name: string } }> }, orders: Array<{ __typename?: 'Order', cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, variant?: any | null, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } }> }> };

export type GetPreferencesFromSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferencesFromSubscriptionsQuery = { __typename?: 'Query', subscriptions: Array<{ __typename?: 'SubscriptionEntity', legacyOrderId: number, recurring: boolean, preferences: { __typename?: 'SubscriptionPreferences', mealSize: string, ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoid', displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategory', displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'Tag', value: string, displayValue: string, category: { __typename?: 'TagCategory', name: string } }>, mealTypes: Array<{ __typename?: 'Tag', value: string, displayValue: string, category: { __typename?: 'TagCategory', name: string } }> }, location: { __typename?: 'Location', zip: string, state: string } }> };

export type TagFieldsFragment = { __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } };

export type RangeFragment = { __typename?: 'Range', min: number, max?: number | null };

export type SubMgmtFieldsFragment = { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, phone?: string | null, dropoffLocation?: string | null }, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategoryV2', legacyAllergenCategoryId: number, displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null, skuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', quantity: number, priority: number, day: string, sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }>, skuOptOuts: Array<{ __typename?: 'SkuOptOutGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null };

export type DashboardSubscriptionFragment = { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, mealsPerWeek: number, pauses: any, metro: { __typename?: 'MetroV2', legacyRailsId: number, shoppableDeliveryDates: Array<any>, legacySystemShoppableDeliveryDates: Array<any>, currentModifyDeadline: any }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, dropoffLocation?: string | null }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'CreditCardV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', displayName: string }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }> }, carts: Array<{ __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } }> };

export type UpdateSubscriptionPrefsMutationVariables = Exact<{
  prefs: UpdateSubscriptionPrefsInput;
}>;


export type UpdateSubscriptionPrefsMutation = { __typename?: 'Mutation', updateSubscriptionPrefs: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, phone?: string | null, dropoffLocation?: string | null }, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategoryV2', legacyAllergenCategoryId: number, displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null, skuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', quantity: number, priority: number, day: string, sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }>, skuOptOuts: Array<{ __typename?: 'SkuOptOutGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null } };

export type UpdateSubscriptionLocationV2MutationVariables = Exact<{
  input: UpdateSubscriptionLocationInput;
}>;


export type UpdateSubscriptionLocationV2Mutation = { __typename?: 'Mutation', updateSubscriptionLocation: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, phone?: string | null, dropoffLocation?: string | null }, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategoryV2', legacyAllergenCategoryId: number, displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null, skuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', quantity: number, priority: number, day: string, sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }>, skuOptOuts: Array<{ __typename?: 'SkuOptOutGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null } };

export type UpdatePaymentMethodV2MutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  paymentMethodId: Scalars['Int']['input'];
}>;


export type UpdatePaymentMethodV2Mutation = { __typename?: 'Mutation', updatePaymentMethod: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, phone?: string | null, dropoffLocation?: string | null }, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategoryV2', legacyAllergenCategoryId: number, displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null, skuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', quantity: number, priority: number, day: string, sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }>, skuOptOuts: Array<{ __typename?: 'SkuOptOutGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null } };

export type CancelSubscriptionMutationVariables = Exact<{
  subId: Scalars['UUID']['input'];
  cancellationReason?: InputMaybe<SubscriptionCancellationReason>;
  userComments?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscriptionV2: { __typename?: 'SubscriptionEntityV2', cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null } };

export type ModifySubscriptionPausesMutationVariables = Exact<{
  uuid: Scalars['UUID']['input'];
  pauseMap: Scalars['JSONObject']['input'];
}>;


export type ModifySubscriptionPausesMutation = { __typename?: 'Mutation', modifySubscriptionPauses: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, mealsPerWeek: number, pauses: any, metro: { __typename?: 'MetroV2', legacyRailsId: number, shoppableDeliveryDates: Array<any>, legacySystemShoppableDeliveryDates: Array<any>, currentModifyDeadline: any }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, dropoffLocation?: string | null }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'CreditCardV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', displayName: string }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }> }, carts: Array<{ __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } }> } };

export type UpdateBulkSubscriptionSkuFavoritesMutationVariables = Exact<{
  input: UpdateSkuFavoritesInput;
}>;


export type UpdateBulkSubscriptionSkuFavoritesMutation = { __typename?: 'Mutation', updateBulkSubscriptionSkuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> };

export type UpdateBulkSubscriptionSkuOptOutMutationVariables = Exact<{
  subscriptionUuid: Scalars['String']['input'];
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateBulkSubscriptionSkuOptOutMutation = { __typename?: 'Mutation', updateBulkSubscriptionSkuOptOut: Array<{ __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string }> };

export type GetSubscriptionUuiDsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionUuiDsV2Query = { __typename?: 'Query', dashboardSubscriptionsV2: Array<{ __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, status: string, displayName: string, carts: Array<{ __typename?: 'Cart', uuid: any }> }> };

export type GetSubscriptionV2ByUuidQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetSubscriptionV2ByUuidQuery = { __typename?: 'Query', subscriptionV2: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, carts: Array<{ __typename?: 'Cart', status: CartStatus, customizeBy?: any | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', status: CartStatus, customizeBy?: any | null } }>, cancellation?: { __typename?: 'SubscriptionCancellation', createdAt: any } | null, subscriptionDeliveries: Array<{ __typename?: 'SubscriptionDeliveryV2', day: string, quantity: number }>, metro: { __typename?: 'MetroV2', legacyRailsId: number }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, phone?: string | null, dropoffLocation?: string | null }, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', legacyAllergenItemId: number, displayName: string, isAllergen: boolean, category: { __typename?: 'IngredientToAvoidCategoryV2', legacyAllergenCategoryId: number, displayName: string } }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, tags: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, macros?: { __typename?: 'MacroPreferencesGraphQL', calories?: { __typename?: 'Range', min: number, max?: number | null } | null, cholesterolInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, dietaryFiberInG?: { __typename?: 'Range', min: number, max?: number | null } | null, netCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, proteinInG?: { __typename?: 'Range', min: number, max?: number | null } | null, saturatedFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, servingSizeInOz?: { __typename?: 'Range', min: number, max?: number | null } | null, sodiumInMg?: { __typename?: 'Range', min: number, max?: number | null } | null, sugarsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalFatInG?: { __typename?: 'Range', min: number, max?: number | null } | null, totalCarbsInG?: { __typename?: 'Range', min: number, max?: number | null } | null, addedSugarInG?: { __typename?: 'Range', min: number, max?: number | null } | null } | null, skuFavorites: Array<{ __typename?: 'SkuFavoriteGraphQL', quantity: number, priority: number, day: string, sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }>, skuOptOuts: Array<{ __typename?: 'SkuOptOutGraphQL', sku: { __typename?: 'Sku', sku: string, title: string, subtitle?: string | null, photoUrl: string } }> }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'CreditCardV2', displayName: string, network: string, expirationMonth: string, expirationYear: string, lastFour: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null } };

export type GetSubscriptionV2ByUuidDashboardQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetSubscriptionV2ByUuidDashboardQuery = { __typename?: 'Query', subscriptionV2: { __typename?: 'SubscriptionEntityV2', uuid: any, startWeek: any, endWeek?: any | null, legacyOrderId?: number | null, displayName: string, status: string, mealsPerWeek: number, pauses: any, metro: { __typename?: 'MetroV2', legacyRailsId: number, shoppableDeliveryDates: Array<any>, legacySystemShoppableDeliveryDates: Array<any>, currentModifyDeadline: any }, location: { __typename?: 'SubscriptionLocationV2', city: string, state: string, zip: string, addressLine1: string, addressLine2?: string | null, recipient: string, dropoffLocation?: string | null }, paymentMethod?: { __typename?: 'ApplePayV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'CreditCardV2', displayName: string, expirationMonth: string, expirationYear: string, lastFour: string, network: string } | { __typename?: 'PayPalV2', displayName: string, email: string } | null, preferences: { __typename?: 'SubscriptionPreferencesV2', ingredientsToAvoid: Array<{ __typename?: 'IngredientToAvoidV2', displayName: string }>, dietaryTemplates: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }>, mealTypes: Array<{ __typename?: 'TagV2', id: number, displayName: string, category: { __typename?: 'TagCategoryV2', id: number, name: string } }> }, carts: Array<{ __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null }>, orders: Array<{ __typename?: 'Order', fulfilled: boolean, cart: { __typename?: 'Cart', uuid: any, userId?: number | null, orderOn?: any | null, customizeBy?: any | null, deliveryDates: any, deliveryWeek: any, createdAt: any, legacyOrderId?: number | null, funnelData: any, cartDeliveries: Array<{ __typename?: 'CartDelivery', id: number, createdAt: any, updatedAt: any, locationId?: number | null, status: number, deliveryType: number, estimatedTransitTime?: number | null, estimatedDeliveryDate?: any | null, deliveryDate: any, orderDelivery?: { __typename?: 'OrderDelivery', trackingId?: string | null, trackingUrl?: string | null } | null, lineItems: Array<{ __typename?: 'CartDeliveryLineItem', id: number, createdAt: any, updatedAt: any, variantId: number, price: number, quantity: number }> }>, cartLedger?: { __typename?: 'CartLedger', id: number, createdAt: any, updatedAt: any, subtotal: number, discountTotal: number, deliveryTotal: number, tax: number, grandTotal: number, creditTotal: number, precreditTotal: number } | null, discount?: { __typename?: 'Discount', amount: number, code: string, type: string } | null, cartError?: { __typename?: 'CartError', validation?: { __typename?: 'CartValidation', quantity?: Array<{ __typename?: 'ValidationError', message: string, deliveryId?: number | null }> | null, status?: Array<{ __typename?: 'ValidationError', message: string }> | null, catalog?: Array<{ __typename?: 'ValidationError', message: string }> | null, customizeBy?: Array<{ __typename?: 'ValidationError', message: string }> | null } | null } | null } }> } };
